export default __webpack_public_path__ + "static/media/copy-bg-2.53c5ded7.svg";